import styled from "styled-components";
import { designTokens, getTypography } from "@/styles/designTokens";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 680px;
  width: 100%;
  margin: 0 auto;
  padding: 80px 40px;
  color: ${designTokens.colors.font.primary};
`;

export const Header = styled.div`
  margin-bottom: 40px;
`;

export const Title = styled.h2`
  ${getTypography("english", "headline2")};
  font-weight: 600;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  ${getTypography("korean", "body3")};
  color: ${designTokens.colors.font.tertiary};
  line-height: 1.6;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const commonInput = `
  ${getTypography("korean", "body3")};
  border: none;
  border-bottom: 1px solid #e2e6ef;
  background: transparent;
  padding: 10px 4px;
  color: ${designTokens.colors.font.primary};
  transition: all 0.2s ease;

  &::placeholder {
    color: ${designTokens.colors.font.tertiary};
  }

  &:focus {
    outline: none;
    border-color: #5c6eff;
  }
`;

export const Input = styled.input`
  ${commonInput};
  height: 44px;
`;

export const Textarea = styled.textarea`
  ${commonInput};
  height: 120px;
  resize: none;
`;

export const Button = styled.button`
  ${getTypography("korean", "body2")};
  align-self: flex-end;
  padding: 10px 24px;
  background: transparent;
  color: #5c6eff;
  border: 1px solid #5c6eff;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.25s ease;

  &:hover {
    background: #5c6eff;
    color: #fff;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
`;
